module.exports = __webpack_public_path__ + "img/月亮icon_white.01647c1a.svg";